import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from 'services/toast.service';
import { MAX_LENGTH_NAME, MIN_LENGTH_NAME, getControlsWithErrors } from 'util/form.utility';
import { BaseFormModalComponent } from '../base-form-modal.component';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { NgClass } from '@angular/common';
import { ResearchTopicByClientIdCard } from 'types/client.interface';
import { ReadingRoomSubmissionResearchTopicItem } from 'types/service.interface';
@Component({
  selector: 'app-requires-restricted-access-modal',
  standalone: true,
  imports: [TranslateModule, FormsModule, SpinnerComponent, ReactiveFormsModule, NgClass],
  templateUrl: './requires-restricted-access-modal.component.html',
  styleUrl: './requires-restricted-access-modal.component.scss'
})
export class RequiresRestrictedAccessModalComponent extends BaseFormModalComponent implements OnInit {
  @Input() topic!: ReadingRoomSubmissionResearchTopicItem | ResearchTopicByClientIdCard;
  @Input() isOpen = false;

  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  public readonly maxFieldLength = MAX_LENGTH_NAME;
  get restrictedAccessJustification(): AbstractControl<any, any> | null {
    return this.form.get('restrictedAccessJustification');
  }

  constructor(
    formBuilder: FormBuilder,
    config: NgbModalConfig,
    modalService: NgbModal,
    toastService: ToastService,
    translateService: TranslateService
  ) {
    super(formBuilder, config, modalService, toastService, translateService);
  }

  ngOnInit() {
    this.fillForm();
  }

  fillForm(): void {
    this.form = this.formBuilder.group({
      restrictedAccessJustification: [
        '',
        [Validators.required, Validators.maxLength(MAX_LENGTH_NAME), Validators.minLength(MIN_LENGTH_NAME)]
      ]
    });
  }

  handleSave() {
    if (this.form.valid) {
      this.submitAttempted = false;
      this.save.emit({
        ...this.topic,
        restrictedAccessJustification: this.restrictedAccessJustification?.value
      });
      this.close();
    } else {
      this.submitAttempted = true;
      this.toastService.showFormValidationError(getControlsWithErrors(this.form), 'pages.client.readersCard');
    }
  }

  resetForm(): void {
    this.restrictedAccessJustification?.setValue('');
  }

  protected override close(): void {
    this.resetForm();
    super.close();
  }
}
